import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card border-0 rounded-3 mb-4 bg-white shadow-sm" }
const _hoisted_2 = { class: "card-header bg-light-subtle d-flex justify-content-between align-items-center py-3 px-4" }
const _hoisted_3 = { class: "d-flex align-items-center gap-2" }
const _hoisted_4 = { class: "mb-0 fs-15 fw-bold text-dark d-flex align-items-center gap-2" }
const _hoisted_5 = {
  key: 0,
  class: "badge bg-success-subtle text-success fs-12 px-3 py-2"
}
const _hoisted_6 = {
  key: 1,
  class: "badge bg-warning-subtle text-warning fs-12 px-3 py-2"
}
const _hoisted_7 = { class: "card-body p-4" }
const _hoisted_8 = {
  key: 0,
  class: "mb-4 p-3 rounded-3 bg-light border border-light-subtle"
}
const _hoisted_9 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3" }
const _hoisted_10 = { class: "fw-bold text-primary mb-0" }
const _hoisted_11 = { class: "d-flex gap-2" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}
const _hoisted_14 = ["href"]
const _hoisted_15 = ["href"]
const _hoisted_16 = { class: "row g-2 fs-13" }
const _hoisted_17 = { class: "col-md-3" }
const _hoisted_18 = { class: "fw-bold text-dark ms-1" }
const _hoisted_19 = { class: "col-md-3" }
const _hoisted_20 = { class: "col-md-3" }
const _hoisted_21 = { class: "col-md-3" }
const _hoisted_22 = { class: "fw-bold text-dark ms-1" }
const _hoisted_23 = { class: "row mb-3" }
const _hoisted_24 = { class: "col-md-3 mb-2" }
const _hoisted_25 = { class: "col-md-3 mb-2" }
const _hoisted_26 = { class: "col-md-3 mb-2" }
const _hoisted_27 = { class: "col-md-3 mb-2" }
const _hoisted_28 = { class: "row mb-3" }
const _hoisted_29 = { class: "col-md-6 mb-2" }
const _hoisted_30 = { class: "col-md-6 mb-2" }
const _hoisted_31 = { class: "p-3 bg-light rounded-2 mb-3 border" }
const _hoisted_32 = { class: "row" }
const _hoisted_33 = { class: "col-md-3 mb-2" }
const _hoisted_34 = { class: "col-md-3 mb-2" }
const _hoisted_35 = { class: "col-md-3 mb-2" }
const _hoisted_36 = { class: "col-md-3 mb-2" }
const _hoisted_37 = { class: "col-md-6 mb-2" }
const _hoisted_38 = { class: "col-md-6 mb-2" }
const _hoisted_39 = { class: "card border rounded-3 mb-3 shadow-sm" }
const _hoisted_40 = { class: "card-body p-3" }
const _hoisted_41 = { class: "p-3 bg-light-subtle rounded border mb-3" }
const _hoisted_42 = { class: "row g-2" }
const _hoisted_43 = { class: "col-md-4" }
const _hoisted_44 = { class: "col-md-8" }
const _hoisted_45 = { class: "card border rounded-3 mb-3 bg-light-subtle shadow-sm" }
const _hoisted_46 = { class: "card-body p-3 d-flex flex-wrap justify-content-between align-items-center gap-2" }
const _hoisted_47 = { class: "form-check d-flex align-items-center m-0" }
const _hoisted_48 = {
  key: 0,
  class: "badge bg-success-subtle text-success fs-11 px-2 py-1 border border-success-subtle d-inline-flex align-items-center gap-1"
}
const _hoisted_49 = {
  key: 1,
  class: "badge bg-secondary-subtle text-secondary fs-11 px-2 py-1 border border-secondary-subtle d-inline-flex align-items-center gap-1"
}
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { class: "d-flex align-items-center justify-content-between mb-2" }
const _hoisted_52 = { class: "d-flex gap-2" }
const _hoisted_53 = { class: "table-responsive" }
const _hoisted_54 = { class: "table table-sm align-middle fs-12 mb-0" }
const _hoisted_55 = ["onUpdate:modelValue"]
const _hoisted_56 = { class: "input-group input-group-sm" }
const _hoisted_57 = ["onUpdate:modelValue"]
const _hoisted_58 = { class: "input-group input-group-sm" }
const _hoisted_59 = ["onUpdate:modelValue"]
const _hoisted_60 = ["onUpdate:modelValue"]
const _hoisted_61 = { class: "text-center" }
const _hoisted_62 = ["onClick"]
const _hoisted_63 = { key: 0 }
const _hoisted_64 = { class: "row mb-3" }
const _hoisted_65 = { class: "col-md-4 mb-2" }
const _hoisted_66 = { class: "col-md-4 mb-2" }
const _hoisted_67 = { class: "col-md-4 mb-2" }
const _hoisted_68 = { class: "col-12 mt-2" }
const _hoisted_69 = { class: "card bg-light-subtle border p-3 rounded-3 mb-2" }
const _hoisted_70 = { class: "row g-3" }
const _hoisted_71 = { class: "col-md-4" }
const _hoisted_72 = { class: "col-md-4" }
const _hoisted_73 = ["value"]
const _hoisted_74 = { class: "col-md-4" }
const _hoisted_75 = {
  key: 0,
  class: "col-12 mt-1"
}
const _hoisted_76 = { class: "d-flex align-items-center gap-3 p-2 bg-white rounded border" }
const _hoisted_77 = ["src"]
const _hoisted_78 = { class: "col-12 mt-2" }
const _hoisted_79 = { class: "form-check" }
const _hoisted_80 = { class: "d-flex justify-content-end gap-2 mt-4" }
const _hoisted_81 = ["disabled"]
const _hoisted_82 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[33] || (_cache[33] = _createElementVNode("span", { class: "material-symbols-outlined text-primary fs-22" }, "smart_toy", -1)),
        _createElementVNode("h5", _hoisted_4, [
          _cache[32] || (_cache[32] = _createElementVNode("span", null, "Protokol Uji Deteksi AI (SOP RBN/SOP-RC/AI/001)", -1)),
          (_ctx.order?.ai_check_detail?.ai_engine)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(["badge", _ctx.order.ai_check_detail.ai_engine === 'scispace' ? 'bg-info-subtle text-info border border-info' : 'bg-primary-subtle text-primary border border-primary'])
              }, " Engine: " + _toDisplayString(_ctx.order.ai_check_detail.ai_engine === 'scispace' ? 'SciSpace' : 'Drillbit'), 3))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.protocol)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.protocol.protocol_number), 1))
        : (_openBlock(), _createElementBlock("span", _hoisted_6, " Belum Dibuat "))
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_ctx.protocol)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", null, [
                _cache[34] || (_cache[34] = _createElementVNode("div", { class: "text-muted fs-12" }, "Nomor Protokol Resmi", -1)),
                _createElementVNode("h5", _hoisted_10, _toDisplayString(_ctx.protocol.protocol_number), 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.generatePdf && _ctx.generatePdf(...args))),
                  disabled: _ctx.generatingPdf,
                  class: "btn btn-sm btn-outline-primary d-flex align-items-center gap-1"
                }, [
                  (_ctx.generatingPdf)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13))
                    : _createCommentVNode("", true),
                  _cache[35] || (_cache[35] = _createElementVNode("span", { class: "material-symbols-outlined fs-16" }, "picture_as_pdf", -1)),
                  _createElementVNode("span", null, _toDisplayString(_ctx.generatingPdf ? 'Membuat PDF...' : 'Regenerate PDF Protokol'), 1)
                ], 8, _hoisted_12),
                (_ctx.order.generated_protocol_pdf)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: _ctx.getFileUrl(_ctx.order.generated_protocol_pdf),
                      target: "_blank",
                      class: "btn btn-sm btn-success d-flex align-items-center gap-1"
                    }, _cache[36] || (_cache[36] = [
                      _createElementVNode("span", { class: "material-symbols-outlined fs-16" }, "download", -1),
                      _createElementVNode("span", null, "Unduh Dokumen Resmi A4", -1)
                    ]), 8, _hoisted_14))
                  : _createCommentVNode("", true),
                (_ctx.protocol.verification?.verification_code)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      href: _ctx.getVerificationUrl(_ctx.protocol.verification.verification_code),
                      target: "_blank",
                      class: "btn btn-sm btn-info text-white d-flex align-items-center gap-1"
                    }, _cache[37] || (_cache[37] = [
                      _createElementVNode("span", { class: "material-symbols-outlined fs-16" }, "verified", -1),
                      _createElementVNode("span", null, "Cek Verifikasi Publik", -1)
                    ]), 8, _hoisted_15))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _cache[38] || (_cache[38] = _createElementVNode("span", { class: "text-muted" }, "Skor Deteksi AI:", -1)),
                _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.protocol.ai_score_initial) + "% → " + _toDisplayString(_ctx.protocol.ai_score_final) + "%", 1)
              ]),
              _createElementVNode("div", _hoisted_19, [
                _cache[39] || (_cache[39] = _createElementVNode("span", { class: "text-muted" }, "Zona Deteksi:", -1)),
                _createElementVNode("span", {
                  class: _normalizeClass(["badge ms-1", _ctx.protocol.ai_score_final <= _ctx.protocol.applied_threshold ? 'bg-success' : 'bg-warning'])
                }, _toDisplayString(_ctx.protocol.internal_zone), 3)
              ]),
              _createElementVNode("div", _hoisted_20, [
                _cache[40] || (_cache[40] = _createElementVNode("span", { class: "text-muted" }, "Status:", -1)),
                _createElementVNode("span", {
                  class: _normalizeClass(["badge ms-1", _ctx.protocol.status_code === 'PASS' ? 'bg-success' : 'bg-danger'])
                }, _toDisplayString(_ctx.protocol.status_code), 3)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _cache[41] || (_cache[41] = _createElementVNode("span", { class: "text-muted" }, "Total Run Siklus:", -1)),
                _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.protocol.total_runs_count) + " Run", 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("form", {
        onSubmit: _cache[31] || (_cache[31] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveProtocol && _ctx.saveProtocol(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _cache[42] || (_cache[42] = _createElementVNode("label", { class: "form-label fs-13 fw-semibold" }, [
              _createTextVNode("Perangkat AI Detector "),
              _createElementVNode("span", { class: "text-danger" }, "*")
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-sm",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.detector_name) = $event)),
              required: "",
              placeholder: "SciSpace AI / Drillbit"
            }, null, 512), [
              [_vModelText, _ctx.form.detector_name]
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _cache[44] || (_cache[44] = _createElementVNode("label", { class: "form-label fs-13 fw-semibold" }, "AI Engine Type", -1)),
            _withDirectives(_createElementVNode("select", {
              class: "form-select form-select-sm",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.engine_type) = $event)),
              onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onEngineTypeChange && _ctx.onEngineTypeChange(...args)))
            }, _cache[43] || (_cache[43] = [
              _createElementVNode("option", { value: "SciSpace" }, "SciSpace", -1),
              _createElementVNode("option", { value: "Drillbit" }, "Drillbit", -1),
              _createElementVNode("option", { value: "Turnitin AI" }, "Turnitin AI", -1),
              _createElementVNode("option", { value: "GPTZero" }, "GPTZero", -1)
            ]), 544), [
              [_vModelSelect, _ctx.form.engine_type]
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _cache[45] || (_cache[45] = _createElementVNode("label", { class: "form-label fs-13 fw-semibold" }, "Versi Perangkat", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-sm",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.detector_version) = $event)),
              placeholder: "2026 Model Release"
            }, null, 512), [
              [_vModelText, _ctx.form.detector_version]
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _cache[46] || (_cache[46] = _createElementVNode("label", { class: "form-label fs-13 fw-semibold" }, [
              _createTextVNode("Bahasa Naskah "),
              _createElementVNode("span", { class: "text-danger" }, "*")
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-sm",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.document_language) = $event)),
              required: "",
              placeholder: "Bahasa Indonesia / English"
            }, null, 512), [
              [_vModelText, _ctx.form.document_language]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _cache[47] || (_cache[47] = _createElementVNode("label", { class: "form-label fs-13 fw-semibold" }, "Lingkup Teks Dianalisis", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-sm",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.analyzed_scope) = $event)),
              required: "",
              placeholder: "Seluruh bab naskah utama (abstrak s.d. kesimpulan)"
            }, null, 512), [
              [_vModelText, _ctx.form.analyzed_scope]
            ])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _cache[48] || (_cache[48] = _createElementVNode("label", { class: "form-label fs-13 fw-semibold" }, "Lingkup Dikecualikan", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-sm",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.excluded_scope) = $event)),
              placeholder: "Daftar pustaka, lampiran, ucapan terima kasih"
            }, null, 512), [
              [_vModelText, _ctx.form.excluded_scope]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _cache[57] || (_cache[57] = _createElementVNode("div", { class: "fw-bold fs-13 mb-2 text-dark" }, "Ambang Batas & Pengukuran Skor AI (SOP RBN)", -1)),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _cache[49] || (_cache[49] = _createElementVNode("label", { class: "form-label fs-12" }, "Ambang Batas Maks. (%)", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "number",
                step: "0.1",
                class: "form-control form-control-sm",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.applied_threshold) = $event)),
                onInput: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.updateZone && _ctx.updateZone(...args))),
                required: ""
              }, null, 544), [
                [_vModelText, _ctx.form.applied_threshold]
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _cache[50] || (_cache[50] = _createElementVNode("label", { class: "form-label fs-12" }, [
                _createTextVNode("Skor AI Awal / Run 1 (%) "),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                type: "number",
                step: "0.1",
                class: "form-control form-control-sm",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.ai_score_initial) = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.form.ai_score_initial]
              ])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _cache[51] || (_cache[51] = _createElementVNode("label", { class: "form-label fs-12" }, [
                _createTextVNode("Skor AI Akhir (%) "),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                type: "number",
                step: "0.1",
                class: "form-control form-control-sm",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.ai_score_final) = $event)),
                onInput: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.updateZone && _ctx.updateZone(...args))),
                required: ""
              }, null, 544), [
                [_vModelText, _ctx.form.ai_score_final]
              ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _cache[53] || (_cache[53] = _createElementVNode("label", { class: "form-label fs-12" }, "Zona Internal RBN", -1)),
              _withDirectives(_createElementVNode("select", {
                class: "form-select form-select-sm",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.internal_zone) = $event)),
                required: ""
              }, _cache[52] || (_cache[52] = [
                _createElementVNode("option", { value: "Rendah (0-20%)" }, "Rendah (0-20%)", -1),
                _createElementVNode("option", { value: "Dalam Batas (21-40%)" }, "Dalam Batas (21-40%)", -1),
                _createElementVNode("option", { value: "Melebihi Batas (41-60%)" }, "Melebihi Batas (41-60%)", -1),
                _createElementVNode("option", { value: "Signifikan (>60%)" }, "Signifikan (>60%)", -1)
              ]), 512), [
                [_vModelSelect, _ctx.form.internal_zone]
              ])
            ]),
            _createElementVNode("div", _hoisted_37, [
              _cache[55] || (_cache[55] = _createElementVNode("label", { class: "form-label fs-12" }, [
                _createTextVNode("Status Kode Keputusan "),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _withDirectives(_createElementVNode("select", {
                class: "form-select form-select-sm",
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.status_code) = $event)),
                required: ""
              }, _cache[54] || (_cache[54] = [
                _createElementVNode("option", { value: "PASS" }, "PASS (Memenuhi Syarat)", -1),
                _createElementVNode("option", { value: "REVISE" }, "REVISE (Perlu Revisi Penulis/Editor)", -1),
                _createElementVNode("option", { value: "CLARIFY" }, "CLARIFY (Perlu Klarifikasi)", -1),
                _createElementVNode("option", { value: "ESCALATE" }, "ESCALATE (Eskalasi ke Head QC)", -1)
              ]), 512), [
                [_vModelSelect, _ctx.form.status_code]
              ])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _cache[56] || (_cache[56] = _createElementVNode("label", { class: "form-label fs-12" }, "Total Siklus Run", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "number",
                class: "form-control form-control-sm",
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.total_runs_count) = $event)),
                min: "1"
              }, null, 512), [
                [_vModelText, _ctx.form.total_runs_count]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_39, [
          _cache[73] || (_cache[73] = _createElementVNode("div", { class: "card-header bg-light d-flex align-items-center justify-content-between py-2 px-3" }, [
            _createElementVNode("div", { class: "d-flex align-items-center gap-2" }, [
              _createElementVNode("span", { class: "material-symbols-outlined text-primary fs-18" }, "pie_chart"),
              _createElementVNode("span", { class: "fw-bold fs-13 text-dark" }, "Distribusi Bobot Deteksi AI (AI Weightage Breakdown)")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, [
              _cache[60] || (_cache[60] = _createElementVNode("div", { class: "fs-12 fw-bold text-dark mb-2 d-flex align-items-center gap-1" }, [
                _createElementVNode("span", { class: "material-symbols-outlined fs-16 text-primary" }, "verified_user"),
                _createElementVNode("span", null, "Klasifikasi Dokumen (Overall Classification)")
              ], -1)),
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _cache[58] || (_cache[58] = _createElementVNode("label", { class: "form-label fs-12 mb-1" }, "Label Klasifikasi Dokumen", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control form-control-sm fw-bold",
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.classification_label) = $event)),
                    placeholder: "cth: Essentially Human 13%"
                  }, null, 512), [
                    [_vModelText, _ctx.form.classification_label]
                  ])
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _cache[59] || (_cache[59] = _createElementVNode("label", { class: "form-label fs-12 mb-1" }, "Keterangan / Deskripsi Evaluasi", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control form-control-sm",
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.classification_desc) = $event)),
                    placeholder: "cth: Contains small portions of AI-generated text. The rest appears written by a human."
                  }, null, 512), [
                    [_vModelText, _ctx.form.classification_desc]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input mt-0",
                    type: "checkbox",
                    id: "describeWeightageCheck",
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.describeWeightage) = $event)),
                    onChange: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.onDescribeWeightageChange && _ctx.onDescribeWeightageChange(...args))),
                    style: {"cursor":"pointer","width":"1.25em","height":"1.25em"}
                  }, null, 544), [
                    [_vModelCheckbox, _ctx.describeWeightage]
                  ]),
                  _cache[61] || (_cache[61] = _createElementVNode("label", {
                    class: "form-check-label fw-bold text-dark fs-13 ms-2 mb-0",
                    for: "describeWeightageCheck",
                    style: {"cursor":"pointer"}
                  }, " Deskripsikan Rincian Pembobotan Deteksi AI (AI Weightage Levels) ", -1)),
                  _cache[62] || (_cache[62] = _createElementVNode("span", { class: "text-muted fs-12 ms-2" }, "(Centang jika ingin mengisi pembobotan Highly, Moderately, Lowly, Human. Opsional)", -1))
                ]),
                _createElementVNode("div", null, [
                  (_ctx.describeWeightage)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_48, [
                        _cache[63] || (_cache[63] = _createElementVNode("span", { class: "material-symbols-outlined fs-13" }, "visibility", -1)),
                        _createElementVNode("span", null, "Aktif (" + _toDisplayString(_ctx.form.section_reviews.length) + " Baris Bobot)", 1)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_49, _cache[64] || (_cache[64] = [
                        _createElementVNode("span", { class: "material-symbols-outlined fs-13" }, "visibility_off", -1),
                        _createElementVNode("span", null, "Default: Tidak Dijabarkan (Opsional)", -1)
                      ])))
                ])
              ])
            ]),
            (_ctx.describeWeightage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _cache[67] || (_cache[67] = _createElementVNode("div", { class: "fs-12 fw-bold text-dark d-flex align-items-center gap-1" }, [
                      _createElementVNode("span", { class: "material-symbols-outlined fs-16 text-primary" }, "bar_chart"),
                      _createElementVNode("span", null, "Rincian Pembobotan Deteksi AI (AI Weightage Levels)")
                    ], -1)),
                    _createElementVNode("div", _hoisted_52, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.applySciSpacePreset && _ctx.applySciSpacePreset(...args))),
                        class: "btn btn-xs btn-outline-secondary d-flex align-items-center gap-1 fs-11"
                      }, _cache[65] || (_cache[65] = [
                        _createElementVNode("span", { class: "material-symbols-outlined fs-14" }, "auto_fix_high", -1),
                        _createElementVNode("span", null, "Preset Standar SciSpace", -1)
                      ])),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.addSectionReview && _ctx.addSectionReview(...args))),
                        class: "btn btn-xs btn-primary d-flex align-items-center gap-1 fs-11"
                      }, _cache[66] || (_cache[66] = [
                        _createElementVNode("span", { class: "material-symbols-outlined fs-14" }, "add", -1),
                        _createElementVNode("span", null, "Tambah Baris", -1)
                      ]))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("table", _hoisted_54, [
                      _cache[72] || (_cache[72] = _createElementVNode("thead", { class: "table-light" }, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", { style: {"width":"28%"} }, "Tingkat Bobot AI (Weightage Level)"),
                          _createElementVNode("th", {
                            style: {"width":"16%"},
                            class: "text-center"
                          }, "Persentase Konten (%)"),
                          _createElementVNode("th", {
                            style: {"width":"16%"},
                            class: "text-center"
                          }, "Jumlah Kalimat"),
                          _createElementVNode("th", { style: {"width":"35%"} }, "Karakteristik / Catatan Kalimat"),
                          _createElementVNode("th", {
                            style: {"width":"5%"},
                            class: "text-center"
                          }, "Hapus")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.section_reviews, (sec, idx) => {
                          return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                            _createElementVNode("td", null, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "form-control form-control-sm fw-semibold",
                                "onUpdate:modelValue": ($event: any) => ((sec.weightage_level) = $event),
                                placeholder: "cth: Highly AI written [H]",
                                required: ""
                              }, null, 8, _hoisted_55), [
                                [_vModelText, sec.weightage_level]
                              ])
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", _hoisted_56, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "number",
                                  step: "0.1",
                                  class: "form-control form-control-sm text-center",
                                  "onUpdate:modelValue": ($event: any) => ((sec.content_pct) = $event),
                                  placeholder: "0"
                                }, null, 8, _hoisted_57), [
                                  [
                                    _vModelText,
                                    sec.content_pct,
                                    void 0,
                                    { number: true }
                                  ]
                                ]),
                                _cache[68] || (_cache[68] = _createElementVNode("span", { class: "input-group-text px-1" }, "%", -1))
                              ])
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", _hoisted_58, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "number",
                                  class: "form-control form-control-sm text-center",
                                  "onUpdate:modelValue": ($event: any) => ((sec.sentences_count) = $event),
                                  placeholder: "0"
                                }, null, 8, _hoisted_59), [
                                  [
                                    _vModelText,
                                    sec.sentences_count,
                                    void 0,
                                    { number: true }
                                  ]
                                ]),
                                _cache[69] || (_cache[69] = _createElementVNode("span", { class: "input-group-text px-1" }, "klm", -1))
                              ])
                            ]),
                            _createElementVNode("td", null, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "form-control form-control-sm",
                                "onUpdate:modelValue": ($event: any) => ((sec.context_note) = $event),
                                placeholder: "Deskripsi karakteristik..."
                              }, null, 8, _hoisted_60), [
                                [_vModelText, sec.context_note]
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_61, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: ($event: any) => (_ctx.removeSectionReview(idx)),
                                class: "btn btn-sm btn-outline-danger p-1 border-0"
                              }, _cache[70] || (_cache[70] = [
                                _createElementVNode("span", { class: "material-symbols-outlined fs-16" }, "delete", -1)
                              ]), 8, _hoisted_62)
                            ])
                          ]))
                        }), 128)),
                        (_ctx.form.section_reviews.length === 0)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_63, _cache[71] || (_cache[71] = [
                              _createElementVNode("td", {
                                colspan: "5",
                                class: "text-center text-muted py-3 bg-light-subtle rounded border border-dashed"
                              }, [
                                _createTextVNode(" Belum ada rincian pembobotan. Klik "),
                                _createElementVNode("strong", null, "\"Preset Standar SciSpace\""),
                                _createTextVNode(" untuk memuat pembagian 4 tingkat bobot AI standar atau "),
                                _createElementVNode("strong", null, "\"Tambah Baris\""),
                                _createTextVNode(". ")
                              ], -1)
                            ])))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_64, [
          _createElementVNode("div", _hoisted_65, [
            _cache[74] || (_cache[74] = _createElementVNode("label", { class: "form-label fs-13 fw-semibold" }, [
              _createTextVNode("Nama Pengguna / Penulis (Tampil di Protokol & PDF) "),
              _createElementVNode("span", { class: "text-danger" }, "*")
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-sm",
              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.form.author_name_masked) = $event)),
              required: "",
              placeholder: "Nama pengguna / penulis"
            }, null, 512), [
              [_vModelText, _ctx.form.author_name_masked]
            ])
          ]),
          _createElementVNode("div", _hoisted_66, [
            _cache[75] || (_cache[75] = _createElementVNode("label", { class: "form-label fs-13 fw-semibold" }, [
              _createTextVNode("Judul Naskah / Dokumen (Tampil di Protokol & PDF) "),
              _createElementVNode("span", { class: "text-danger" }, "*")
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-sm",
              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.form.document_title_masked) = $event)),
              required: "",
              placeholder: "Judul naskah / dokumen"
            }, null, 512), [
              [_vModelText, _ctx.form.document_title_masked]
            ])
          ]),
          _createElementVNode("div", _hoisted_67, [
            _cache[76] || (_cache[76] = _createElementVNode("label", { class: "form-label fs-13 fw-semibold" }, "Institusi / Afiliasi", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-sm",
              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.form.institution) = $event)),
              placeholder: "Universitas ..."
            }, null, 512), [
              [_vModelText, _ctx.form.institution]
            ])
          ]),
          _createElementVNode("div", _hoisted_68, [
            _createElementVNode("div", _hoisted_69, [
              _cache[83] || (_cache[83] = _createElementVNode("h6", { class: "fs-13 fw-bold text-dark mb-2 d-flex align-items-center gap-1" }, [
                _createElementVNode("span", { class: "material-symbols-outlined fs-18 text-primary" }, "draw"),
                _createElementVNode("span", null, "Pemeriksa & Penandatangan Pengesahan Protokol")
              ], -1)),
              _createElementVNode("div", _hoisted_70, [
                _createElementVNode("div", _hoisted_71, [
                  _cache[77] || (_cache[77] = _createElementVNode("label", { class: "form-label fs-12 fw-semibold" }, [
                    _createTextVNode("Nama Examiner AI "),
                    _createElementVNode("span", { class: "text-danger" }, "*")
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control form-control-sm",
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.form.examiner_name) = $event)),
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.form.examiner_name]
                  ])
                ]),
                _createElementVNode("div", _hoisted_72, [
                  _cache[79] || (_cache[79] = _createElementVNode("label", { class: "form-label fs-12 fw-semibold" }, "Pilih Penandatangan Terdaftar", -1)),
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select form-select-sm",
                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.form.signatory_id) = $event)),
                    onChange: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.onSignatoryChange && _ctx.onSignatoryChange(...args)))
                  }, [
                    _cache[78] || (_cache[78] = _createElementVNode("option", { value: null }, "-- Gunakan Penandatangan Default --", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.signatories, (sig) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: sig.id,
                        value: sig.id
                      }, _toDisplayString(sig.name) + " (" + _toDisplayString(sig.position) + ") " + _toDisplayString(sig.is_default ? '★ Default' : ''), 9, _hoisted_73))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, _ctx.form.signatory_id]
                  ])
                ]),
                _createElementVNode("div", _hoisted_74, [
                  _cache[80] || (_cache[80] = _createElementVNode("label", { class: "form-label fs-12 fw-semibold" }, "Nama & Jabatan Pengesahan", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control form-control-sm mb-1",
                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.form.signatory_name) = $event)),
                    placeholder: "Nama penandatangan"
                  }, null, 512), [
                    [_vModelText, _ctx.form.signatory_name]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control form-control-sm",
                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.form.signatory_position) = $event)),
                    placeholder: "Jabatan penandatangan"
                  }, null, 512), [
                    [_vModelText, _ctx.form.signatory_position]
                  ])
                ]),
                (_ctx.selectedSignatoryPreviewUrl)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                      _createElementVNode("div", _hoisted_76, [
                        _cache[81] || (_cache[81] = _createElementVNode("span", { class: "fs-11 text-muted fw-semibold" }, "Preview Tanda Tangan:", -1)),
                        _createElementVNode("img", {
                          src: _ctx.selectedSignatoryPreviewUrl,
                          alt: "Tanda Tangan",
                          style: {"height":"32px","max-width":"120px","object-fit":"contain"}
                        }, null, 8, _hoisted_77),
                        _cache[82] || (_cache[82] = _createElementVNode("span", { class: "fs-11 text-success d-flex align-items-center gap-1" }, [
                          _createElementVNode("span", { class: "material-symbols-outlined fs-14" }, "check_circle"),
                          _createElementVNode("span", null, "Siap disematkan pada sertifikat protokol")
                        ], -1))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_78, [
            _createElementVNode("div", _hoisted_79, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.form.disclaimer_agreed) = $event)),
                id: "discCheck",
                required: ""
              }, null, 512), [
                [_vModelCheckbox, _ctx.form.disclaimer_agreed]
              ]),
              _cache[84] || (_cache[84] = _createElementVNode("label", {
                class: "form-check-label fs-12 text-secondary",
                for: "discCheck"
              }, " Saya menyetujui Disclaimer Akademik Resmi RBN bahwa deteksi AI bersifat probabilistik dan telah diverifikasi secara manual. ", -1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_80, [
          _createElementVNode("button", {
            type: "submit",
            class: "btn btn-primary px-4 py-2 d-flex align-items-center gap-2",
            disabled: _ctx.submitting
          }, [
            (_ctx.submitting)
              ? (_openBlock(), _createElementBlock("span", _hoisted_82))
              : _createCommentVNode("", true),
            _cache[85] || (_cache[85] = _createElementVNode("span", { class: "material-symbols-outlined fs-18" }, "save", -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.protocol ? 'Perbarui Protokol' : 'Simpan & Terbitkan Protokol RC-AI'), 1)
          ], 8, _hoisted_81)
        ])
      ], 32)
    ])
  ]))
}